import { useLayoutEffect } from 'react';

import { replaceModal } from '#modals/modalsSlice';
import type { Modal as ModalType } from '#modals/modalsSlice';
import { useDispatch } from '#redux';

type CreateAccountModalProps = Extract<
  ModalType,
  { name: 'add-account' }
>['options'];

export function CreateAccountModal(_options: CreateAccountModalProps) {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(replaceModal({ modal: { name: 'add-local-account' } }));
  }, [dispatch]);

  return null;
}
